export default class Article {
    initAll() {
        const buttons = document.querySelectorAll('.article__share');
        Array.prototype.forEach.call(buttons, button => {
            button.addEventListener('click', async (e) => {
                e.preventDefault();
                const article = button.closest('.article') || button.closest('.article-inner');
                this.onShareClick(article, article.dataset.allowPrint);
            });
        });
    }

    onShareClick(article, print = false) {
        const titleEl = article.querySelector('.article__content-title');
        const textEl = article.querySelector('.article__content-text');
        const excerptEl = article.querySelector('.article__content-excerpt');
        const linkElement = article.querySelector('.article__link') || article.querySelector('.betterembed__read-more');
        const articleLink = linkElement ? linkElement.getAttribute('href') : location.href;
        let text = textEl ? textEl.innerText + '\n\n' : '';
        let excerpt = excerptEl ? excerptEl.innerText + '\n\n' : '';
        let lang = document.querySelector('html').lang || 'en';

        navigator.share({
            title: titleEl ? titleEl.innerText : '',
            text: text || excerpt,
            url: articleLink
        }, {
            print,
            language: lang,
            sms: false
        });
    }
}
